import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button, UIText1 } from '@cian/ui-kit';
import { FormCardFooterLayout } from '../../../components/RequestFormV2/FormCardFooterLayout';
import { FormCardLayout } from '../../../components/RequestFormV2/FormCardLayout';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { selectPage, selectPageExtra } from '../../../selectors/analytics';
import { createConsultingRequestWithVerification } from '../../../thunks/consultingRequest/createConsultingRequestWithVerification';
import { trackRequestFormRetry } from '../../../utils/analytics/trackRequestFormRetry';
import { trackRequestFormShowError } from '../../../utils/analytics/trackRequestFormShowError';

const image = 'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-desk-error.png';
const imageMobile = 'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-mob-error.jpg';

export const RequestFormError = (): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const page = useSelector(selectPage);
  const extra = useSelector(selectPageExtra);

  React.useEffect(() => {
    trackRequestFormShowError(page, extra);
  }, [page, extra]);

  const handleNext = () => {
    trackRequestFormRetry(page, extra);
    dispatch(createConsultingRequestWithVerification());
  };

  return (
    <FormCardLayout
      dataTestId="RequestFormV2Error"
      question="Что-то пошло не так"
      image={image}
      imageMobile={imageMobile}
      verticallyCenteredContent={true}
    >
      <UIText1>Проверьте интернет и попробуйте ещё раз</UIText1>

      <FormCardFooterLayout>
        <Button size="M" theme="fill_primary" fullWidth onClick={handleNext}>
          Повторить
        </Button>
      </FormCardFooterLayout>
    </FormCardLayout>
  );
};
